import {Dimensions, ImageBackground} from 'react-native';
import FastImage from 'react-native-fast-image';
import {RFPercentage, RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';

const {height, width} = Dimensions.get('window');

export const ModalOverlay = styled.View`
  flex: 1;
  background-color: rgba(0, 0, 0, 0.5);
  justify-content: center;
  align-items: center;
`;

export const ModalContent = styled.View`
  width: ${width - 20}px;
  flex: 1;
  max-height: ${height * 0.9}px;
  background-color: ${({theme}) => theme.colors.background};
  border-radius: ${RFValue(16)}px;
  overflow: hidden;
`;

export const ModalBody = styled.ScrollView.attrs({
  showsVerticalScrollIndicator: true,
  bounces: false,
  contentContainerStyle: {
    paddingBottom: 20,
  },
})`
  flex: 1;
  padding: ${RFValue(20)}px;
  padding-top: 0;
`;

export const HeaderTitle = styled.Text`
  font-size: ${RFValue(18)}px;
  padding: ${RFValue(20)}px;
  color: ${({theme}) => theme.colors.shape};
  font-family: ${({theme}) => theme.fonts.bold};
`;

export const CloseButton = styled.TouchableOpacity`
  padding: ${RFValue(8)}px;
  justify-content: center;
  align-items: center;
`;

export const CloseButtonText = styled.Text`
  font-size: ${RFValue(18)}px;
  color: ${({theme}) => theme.colors.shape};
  font-family: ${({theme}) => theme.fonts.bold};
`;

export const Container = styled.View`
  flex: 1;
  background: ${({theme}) => theme.colors.background};
`;

export const Description = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text};
  margin-bottom: ${RFValue(20)}px;
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const Bold = styled.Text`
  font-family: ${({theme}) => theme.fonts.bold};
`;

export const List = styled.View`
  margin-bottom: ${RFValue(16)}px;
`;

export const HowItWorksTitle = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(16)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  margin-bottom: ${RFValue(12)}px;
`;

export const TableContainer = styled.View`
  margin-top: ${RFValue(16)}px;
  border-radius: ${RFValue(8)}px;
  overflow: hidden;
  border: 1px solid ${({theme}) => theme.colors.border};
`;

export const TableHeader = styled.View`
  background-color: ${({theme}) => theme.colors.primary};
  padding: ${RFValue(8)}px;
  flex-direction: row;
`;

export const TableHeaderText = styled.Text`
  font-size: ${RFValue(14)}px;
  color: white;
  flex: 1;
  text-align: center;
  font-family: ${({theme}) => theme.fonts.bold};
`;

export const TableRow = styled.View`
  flex-direction: row;
  padding: ${RFValue(8)}px;
  background-color: ${({theme}) => theme.colors.background};
  border-bottom-width: 1px;
  border-bottom-color: ${({theme}) => theme.colors.border};
`;

export const TableRowText = styled.Text`
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.text};
  flex: 1;
  text-align: center;
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const ThumbButton = styled.TouchableOpacity`
  margin-bottom: ${RFValue(16)}px;
  width: 100%;
  height: ${RFPercentage(25)}px;
`;
export const ThumbImage = styled(ImageBackground)`
  width: 100%;
  height: 100%;

  justify-content: flex-start;
`;

export const Header = styled.View`
  align-items: flex-start;
  flex-direction: row;
  width: 100%;
  padding: ${RFValue(12)}px ${RFValue(12)}px;
  justify-content: space-between;
  flex: 1;
`;

export const Footer = styled.View`
  padding: ${RFValue(16)}px ${RFValue(20)}px;
`;
